<template>
  <div :class="{ hidden: !twoFactorAuthData.active }" class="bg-white py-8 px-7 rounded-lg shadow-ts1 lg:w-full w-[96%] max-w-[964px] m-auto">
    <h1 class="text-blue text-3xl lg:text-[40px] leading-10 lg:leading-[72px] mb-10 text-center font-display font-bold">{{ $t('two_factor_setup') }}</h1>
    <p class="text-gray-900 font-semibold text-center text-base leading-7 mb-6">{{ $t('two_factor_setup_text') }}</p>
    <div class="flex justify-center items-center gap-5 mb-7 flex-col md:flex-row">
      <div class="w-full md:w-1/2 h-[425px] lg:h-[420px] border border-gray-300 border-solid shadow-ts2 rounded-lg">
        <div class="h-[50px] w-full mb-4 bg-[#2B63E333] flex justify-center items-center rounded-lg shadow-ts2 text-base text-blue font-display font-bold">
          {{ $t('two_factor_step_1') }}
        </div>
        <p class="text-gray-900 text-base text-center max-w-[292px] mx-auto mb-9">{{ $t('two_factor_step_1_text') }}</p>
        <div class="flex flex-col justify-center items-center gap-4">
          <a href="https://play.google.com/store/search?q=authenticator&c=apps" target="_blank">
            <img src="../../assets/img/google-play-icon.svg" width="230" />
          </a>
          <a href="https://www.apple.com/us/search/authenticator?src=globalnav" target="_blank">
            <img src="../../assets/img/app-store-icon.svg" width="230" />
          </a>
        </div>
      </div>
      <div class="w-full md:w-1/2 h-[425px] lg:h-[420px] border border-gray-300 border-solid shadow-ts2 rounded-lg">
        <div class="h-[50px] w-full mb-4 bg-[#2B63E333] flex justify-center items-center rounded-lg shadow-ts2 text-base text-blue font-display font-bold">
          {{ $t('two_factor_step_2') }}
        </div>
        <p class="text-gray-900 text-base text-center max-w-[292px] mx-auto mb-4">{{ $t('two_factor_step_2_text') }}</p>
        <div class="flex justify-center items-center mb-3">
          <qrcode-vue :value="QRCodeValue" :size="QRCodeSize" level="H" render-as="svg"></qrcode-vue>
        </div>
        <p class="text-gray-900 text-base leading-7 text-center mx-auto mb-1 max-w-[260px] lg:max-w-none">{{ $t('two_factor_step_2_enter_code_text') }}</p>
        <div class="relative bg-gray-100 rounded-md text-center h-[42px] w-auto mx-6 flex items-center lg:justify-center">
          <p class="text-gray-900 text-xs font-display font-bold pl-3 lg:pl-0">{{ twoFactorAuthData.totp }}</p>
          <div @click="copyTOTP()" class="absolute right-2 top-2 cursor-pointer">
            <img src="../../assets/img/copy-icon.svg" width="28" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <button @click="next()" class="bg-blue w-48 h-[50px] text-base font-bold rounded-md text-white flex justify-center items-center">{{ $t('continue').tTitle() }}</button>
    </div>
    <div
      @click="back()"
      class="w-[70px] px-2.5 flex justify-center cursor-pointer rounded-xl mx-auto mt-7 bg-[#2B63E333] font-body text-xs leading-[21px] text-blue items-center gap-1.5"
    >
      <img class="h-3 w-3 inline" src="../../assets/img/back-arrow-blue.svg" />
      {{ $t('back').tTitle() }}
    </div>
  </div>
</template>

<script>
// import { service } from '../main.js'
import { mapActions, mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
  props: ['TwoFactorAuthStep1'],
  components: {
    QrcodeVue,
  },
  data() {
    return {
      twoFactorAuthData: this.TwoFactorAuthStep1,
      QRCodeSize: 160,
      QRCodeValue: '',
    }
  },
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      logoLoaderActive: 'logoLoader/active',
    }),
  },
  mounted() {
    this.$toasted.clear() //clear toasted notifications before the step change
    this.generate_uri()
    this.$bus.$emit('ChangeLang', this.Language)
    const thisCopy = this
    window.addEventListener('popstate', function (event) {
      event.preventDefault()
      thisCopy.$emit('back')
    })
  },
  methods: {
    next() {
      this.$emit('twoFactorStep2')
    },
    generate_uri() {
      var secret = this.twoFactorAuthData.totp.replace(/ /g, '')
      var label = 'Plexytrade'

      var uri = `otpauth://totp/${encodeURIComponent(label)}?secret=${secret}`

      this.QRCodeValue = uri
    },
    copyTOTP() {
      const el = document.createElement('textarea')
      el.value = this.TwoFactorAuthStep1.totp
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
      this.$toasted.success(this.$t('copied'))
    },
    back() {
      this.$emit('back')
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>
